import { ApiResponse } from "../types";
import { Constants } from "../utils/constants";

class SubcategoryFilterService {
  private baseURL: string;

  constructor() {
    this.baseURL = Constants.API_BASE_URL;
  }

  private async makeRequest(endpoint: string, options: RequestInit = {}): Promise<ApiResponse> {
    const url = `${this.baseURL}${endpoint}`;

    let token = localStorage.getItem("authToken");
    if (!token) {
      token = localStorage.getItem("access_token");
    }

    const defaultOptions: RequestInit = {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
    };

    const response = await fetch(url, { ...defaultOptions, ...options });

    let data = null;
    const contentType = response.headers.get("Content-Type") || "";
    if (contentType.includes("application/json")) {
      try {
        data = await response.json();
      } catch (e) {
        data = null;
      }
    }

    return {
      status: response.status,
      data,
      message: data?.message || "",
    };
  }

  // ========================================
  // SUBCATEGORY FILTERS
  // ========================================
  async getSubcategoryFilters(subCategoryId: number): Promise<ApiResponse> {
    return this.makeRequest(`/booking/api/v2/subcategory-filters?subCategoryId=${subCategoryId}`);
  }

  async getSubcategoryFilterById(id: number): Promise<ApiResponse> {
    return this.makeRequest(`/booking/api/v2/subcategory-filters/${id}`);
  }

  async createSubcategoryFilter(payload: { code: string; name: string; subCategoryId: number }): Promise<ApiResponse> {
    return this.makeRequest("/booking/api/v2/subcategory-filters", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  async updateSubcategoryFilter(id: number, payload: { name: string }): Promise<ApiResponse> {
    return this.makeRequest(`/booking/api/v2/subcategory-filters/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  }

  async deleteSubcategoryFilter(id: number): Promise<ApiResponse> {
    return this.makeRequest(`/booking/api/v2/subcategory-filters/${id}`, {
      method: "DELETE",
    });
  }

  // ========================================
  // FILTER OPTIONS
  // ========================================
  async getFilterOptions(filterId: number): Promise<ApiResponse> {
    return this.makeRequest(`/booking/api/v2/subcategory-filters/options?filterId=${filterId}`);
  }

  async createFilterOption(payload: {
    code: string;
    filterId: number;
    image?: string;
    imageType?: string;
    name: string;
    sortOrder: number;
    value: string;
  }): Promise<ApiResponse> {
    return this.makeRequest("/booking/api/v2/subcategory-filters/options", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  async updateFilterOption(
    id: number,
    payload: {
      image?: string;
      imageType?: string;
      name: string;
      sortOrder: number;
      value: string;
    }
  ): Promise<ApiResponse> {
    return this.makeRequest(`/booking/api/v2/subcategory-filters/options/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  }

  async deleteFilterOption(id: number): Promise<ApiResponse> {
    return this.makeRequest(`/booking/api/v2/subcategory-filters/options/${id}`, {
      method: "DELETE",
    });
  }
}

const subcategoryFilterService = new SubcategoryFilterService();
export default subcategoryFilterService;
